module.exports = __webpack_public_path__ + "static/Portfolio09-029a68779aa5e34dfce9c84986622128.jpg";